import React, { useState } from "react";
import { Button, Form, Input, Modal, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";

interface AddCarModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onAdd: (formData: FormData) => void;
}

const AddCarModal: React.FC<AddCarModalProps> = ({
  isOpen,
  isLoading,
  onClose,
  onAdd,
}) => {
  const [form] = Form.useForm();
  const [file, setFile] = useState<any>(null);

  const handleFileChange = (fileList: any) => {
    if (fileList.length > 0) {
      setFile(fileList[0].originFileObj);
    } else {
      setFile(null);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const { CarNumber, Modal, Marka, CarName, Price } = values;

      const formData = new FormData();
      formData.append("CarNumber", CarNumber);
      formData.append("Modal", Modal);
      formData.append("Marka", Marka);
      formData.append("CarName", CarName);
      formData.append("Price", Price);

      if (file) {
        formData.append("CarImageName", file);
      }

      onAdd(formData);
      form.resetFields();
      setFile(null);
    } catch (error) {
      console.error("خطأ أثناء إضافة السيارة:", error);
      message.error("يرجى تعبئة الحقول المطلوبة.");
    }
  };

  return (
    <Modal
      title="إضافة سيارة"
      centered
      open={isOpen}
      onCancel={onClose}
      footer={null}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="رقم السيارة"
          name="CarNumber"
          rules={[{ required: true, message: "يرجى إدخال رقم السيارة" }]}
        >
          <Input placeholder="أدخل رقم السيارة" />
        </Form.Item>
        <Form.Item
          label="الموديل"
          name="Modal"
          rules={[{ required: true, message: "يرجى إدخال الموديل" }]}
        >
          <Input placeholder="أدخل الموديل" />
        </Form.Item>
        <Form.Item
          label="الماركة"
          name="Marka"
          rules={[{ required: true, message: "يرجى إدخال الماركة" }]}
        >
          <Input placeholder="أدخل الماركة" />
        </Form.Item>
        <Form.Item
          label="اسم السيارة"
          name="CarName"
          rules={[{ required: true, message: "يرجى إدخال اسم السيارة" }]}
        >
          <Input placeholder="أدخل اسم السيارة" />
        </Form.Item>
        <Form.Item
          label="السعر"
          name="Price"
          rules={[{ required: true, message: "يرجى إدخال السعر" }]}
        >
          <Input type="number" placeholder="أدخل السعر" />
        </Form.Item>
        <Form.Item label="رفع الصورة">
          <Upload
            customRequest={({ file, onSuccess }) => {
              onSuccess?.("ok");
            }}
            onChange={({ fileList }) => handleFileChange(fileList)}
            listType="picture"
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>رفع الملف</Button>
          </Upload>
        </Form.Item>
        <Button type="primary" onClick={handleSubmit} loading={isLoading}>
          إضافة
        </Button>
      </Form>
    </Modal>
  );
};

export default AddCarModal;
